<template>
  <div class="dataStatistic">
    <div class="dataStatistic-header">
      <div class="title">数据统计</div>
    </div>
    
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:1vh"  class="client-data-statistic">
        <el-tab-pane label="客户资产" name="client-asset">
          <ClientAsset :clientName="clientName" />
        </el-tab-pane>
        <!-- <el-tab-pane label="客户行为" name="client-behaviour">
          <ClientBehaviour :clientName="clientName" />
        </el-tab-pane> -->
        <el-tab-pane label="业绩表现" name="client-performance">
          <ClientPerformance :clientName="clientName" />
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
  import ClientAsset from '@/component/Client/ClientDetail/DataStatistic/ClientAsset'
  import ClientBehaviour from '@/component/Client/ClientDetail/DataStatistic/ClientBehaviour'
  import ClientPerformance from '@/component/Client/ClientDetail/DataStatistic/ClientPerformance'
  export default {
    name: "DataStatistic.vue",
    props: {
      clientName: {
        type: String,
        required: true
      }
    },
    components:{
      ClientAsset,
      ClientBehaviour,
      ClientPerformance
    },
    data(){
      return {
        activeName: 'client-performance'
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>
<style lang="scss">

  .dataStatistic{
    /* width: 80%; */
    width: 100%;
    min-height: 350px;
    padding: 30px;
    box-shadow: 0 0px 10px 6px #f5f5f5;
  }
  .dataStatistic-header{
    display: flex;
    justify-content:space-between;
  }
  .title{
    font-weight: bold;
    font-size:18px
  }
  .client-data-statistic {
    .el-tabs__item {
      min-width: 50px!important;
    }
  }

</style>